import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserPost } from '../../actions/userActions'
import MasoryPostLayout from '../../containers/Post/MasoryPost/MasoryPost'
const PostCampaigns = () => {
  const dispatch = useDispatch()
  const { userInfo,userPosts } = useSelector(state => state.userInfo)
  useEffect(() => {
    //
    if(userInfo._id){
      dispatch(getUserPost(userInfo.franchiseID._id))
    }


    return () => {

    }
  }, [userInfo])

  return (
    <MasoryPostLayout type="profile" masoryPost={userPosts} linkPath={"../Campaigns/"} />
  )
}

export default PostCampaigns